/**
 * Where a person was going when they had to sign in. The path travels in `/login?redirect=…` and is honoured only when
 * it is a same-origin path, so the parameter can never send someone to another site (an open redirect).
 */

const SAME_ORIGIN_PATH = /^\/(?![/\\])/;

interface LocationLike {
  pathname: string;
  search: string;
  hash: string;
}

/** The login page, remembering `location` (home needs no reminder). */
export function loginPath(location: LocationLike): string {
  const target = `${location.pathname}${location.search}${location.hash}`;
  return target === '/' || !SAME_ORIGIN_PATH.test(target) ? '/login' : `/login?redirect=${encodeURIComponent(target)}`;
}

/** Where to go after signing in: the `redirect` parameter when it is a same-origin path, else home. */
export function redirectAfterLogin(search: string): string {
  const target = new URLSearchParams(search).get('redirect')?.trim();
  return target && SAME_ORIGIN_PATH.test(target) && !target.startsWith('/login') ? target : '/';
}
